import i18n from '@/i18n/i18n'
import { RetailerShortSaleService } from '@/services/admin/RetailerShortSaleService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = [
  'by_retailer_id',
  'orderItem.order_id',
  'orderItem.product_id',
  'orderItem.brand_id',
  'order_created_between',
  'order_completed_between'
]

export const allowedIncludes = 'orderItem,orderItem.product,orderItem.order.retailer,orderItem.brand'

export const allowedAppends = 'stock_input_id,short_sale_status'

export const allowedSorts = '-created_at'

export const state = {
  shortSales: null,
  meta: null,
  shortSale: {}
}

export const mutations = {
  SET_SHORT_SALES(state, shortSales) {
    state.shortSales = shortSales.data
    state.meta = shortSales.meta
  },
  SET_SHORT_SALE(state, shortSale) {
    state.shortSale = shortSale.data
  }
}

export const actions = {
  getShortSales({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      let retailerShortSaleService = new RetailerShortSaleService()

      let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

      retailerShortSaleService
        .getShortSales(newQuery)
        .then(response => {
          commit('SET_SHORT_SALES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'warning',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.retailer_short_sale.short_sales')
            })
          }

          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getShortSale({ commit, dispatch }, shortSaleId) {
    return new Promise((resolve, reject) => {
      let retailerShortSaleService = new RetailerShortSaleService()

      retailerShortSaleService
        .getShortSale(shortSaleId)
        .then(response => {
          commit('SET_SHORT_SALE', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'warning',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.retailer_short_sale.short_sale_details')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportShortSales({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      let retailerShortSaleService = new RetailerShortSaleService()

      retailerShortSaleService
        .exportShortSales()
        .then(response => {
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: t('store.admin.retailer_short_sale.short_sales')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.exporting_error', {
                element: t('store.admin.retailer_short_sale.short_sales')
              }) +
              ' ' +
              errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
